(function ($) {

    let $body = $('body'),
        $doc = $(document),
        $win = $(window);

    $doc.ready(() => {
        customProductDetail.init();
    });

    let customProductDetail = {
        cbDebounceFunc: null,

        init: function() {
            this.bindEvents();
            this.backToTopCustom();
            this.hideOnScroll(1120, 'senix--side-nav');
            this.shortenProductTitle();
            this.activateFirstTab();
            this.handleProductVideo(); // uses theme's deferred-media classes
        },

        bindEvents: function() {
            let self = this;

            $win.on('resize', function() {
                self.cbDebounce(function() {
                    self.faqAccordionPopulate();
                }, 250);
            });

            $win.on('scroll', function() {
                self.sideNav();
                self.hideOnScroll(1120, 'senix--side-nav');
            });

            self.handleAnchorClick();
            self.faqAccordionPopulate();
            self.handleAccordionClick();
        },

        cbDebounce: function(_callback, _args, _timeout) {
            if (this.cbDebounceFunc) {
                clearTimeout(this.cbDebounceFunc);
            }
            this.cbDebounceFunc = setTimeout(() => {
                _callback.apply(this);
            }, _timeout);
        },

        activateFirstTab: function() {
            let labels = $('label[for^="tab"]');
            let visibleTabs = labels.filter(function() {
                return $(this).css('display') !== 'none';
            })
            if (visibleTabs.length > 0) {
                let firstVisibleTab = visibleTabs.first().attr('for');
                $('#' + firstVisibleTab).prop('checked', true);
            }
        },

        hideOnScroll: function(_yPosition, _elementId) {
            let element = $('#' + _elementId);
            if ($(window).scrollTop() > _yPosition) {
                element.show();
            } else {
                element.hide();
            }
        },

        backToTopCustom: function() {
            let backToTop = $('#back-to-top');
            if (backToTop.length > 0) {
                let backToTopClone = backToTop.clone();
                backToTopClone.html('<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-up" viewBox="0 0 498.98 284.49"><defs><style>.cls-1{fill:#231f20}</style></defs><path class="cls-1" d="M579.91 486.24A35 35 0 0 1 520.16 511L330.42 321.25 140.68 511a35 35 0 1 1-49.5-49.5L305.67 247a35 35 0 0 1 49.5 0l214.49 214.5a34.89 34.89 0 0 1 10.25 24.74z" transform="translate(-80.93 -236.76)"></path></svg>');
                backToTop.remove();
                backToTopClone.appendTo(backToTop.parent());
                this.hideOnScroll(800, 'back-to-top');

                backToTopClone.on('click', (event) => {
                    event.preventDefault();
                    $('html, body').animate({ scrollTop: 0 }, 'smooth');
                });
            }
        },

        /* ================================
           Handle Product Video (deferred-media)
           ================================ */
        handleProductVideo: function() {
            // Click either the full poster area or the round play button
            $(document).on('click', '.deferred-media__poster, .deferred-media__poster-button', function(e) {
                e.preventDefault();

                const $pv = $(this).closest('.deferred-media'); // wrapper added in Liquid
                if ($pv.length === 0) return;

                const src = $pv.data('src');
                if (!src) return;

                // Mark as loaded so theme CSS hides the poster
                $pv.attr('loaded', '');

                // Build the real player
                const $video = $(`
                  <video class="pd-video-el" playsinline preload="metadata" controls autoplay style="width:100%;height:100%;">
                    <source src="${src}" type="video/mp4">
                  </video>
                `);

                // Remove poster node (extra safety) and insert video
                $pv.find('.deferred-media__poster').remove();
                $pv.append($video);
            });
        },

        faqAccordionPopulate: function() {
            const faqAccordion = $('.faq-container');
            if (faqAccordion.length === 0) return;

            if (!Array.isArray(window.faqAccordionList)) {
                this.handleFaqAccordionClick();
                return;
            }

            faqAccordion.empty();
            let faqAccordionTarget = faqAccordion,
                faqAccordionLeft,
                faqAccordionRight;

            if ($win.outerWidth() >= 1024) {
                faqAccordionLeft = $('<div/>').addClass('faqAccordionLeft');
                faqAccordionRight = $('<div/>').addClass('faqAccordionRight');
                faqAccordion.append(faqAccordionLeft, faqAccordionRight);
            }

            $(window.faqAccordionList).each((_index, _item) => {
                if ($win.outerWidth() >= 1024) {
                    faqAccordionTarget = (_index % 2 === 0) ? faqAccordionLeft : faqAccordionRight;
                } else {
                    faqAccordionTarget = faqAccordion;
                }

                // Handle template
                let faqAccordionTemplateClone = $(window.faqAccordionTemplate).clone();

                let faqAccordionTemplateQuestion = faqAccordionTemplateClone.find('.faqAccordion');
                faqAccordionTemplateQuestion.removeClass('faqActive').text(_item.question);

                let faqAccordionTemplateAnswer = faqAccordionTemplateClone.find('.faqPanel');
                faqAccordionTemplateAnswer.removeClass('faqActive').text(_item.answer);

                faqAccordionTarget.append(faqAccordionTemplateClone);
            });

            this.handleFaqAccordionClick();
        },

        handleFaqAccordionClick: function() {
            $('.faq-block button').off('click.senixFaq').on('click.senixFaq', function() {
                let $this = $(this);
                let $faqPanel = $this.next('.faqPanel');

                // Collapse other open FAQ panels when one is expanded
                $('.faq-block button').not($this).removeClass('faqActive').next('.faqPanel').slideUp(0);

                if (!$this.hasClass('faqActive')) {
                    $this.addClass('faqActive');
                    $faqPanel.slideDown(0);
                } else {
                    $this.removeClass('faqActive');
                    $faqPanel.slideUp(0);
                }
            });
        },

        handleAccordionClick: function(sectionId) {
            let accordions = $('.title-section');
            let panels = $('.content-section');

            if (accordions.length === 0 || panels.length === 0) return;

            const toggleAccordion = ($accordion) => {
                let isActive = $accordion.hasClass('titleSectionActive');
                accordions.removeClass('titleSectionActive');
                panels.removeClass('show');

                if (!isActive) {
                    $accordion.addClass('titleSectionActive');
                    $accordion.next('.content-section').addClass('show');
                }
            };

            if (sectionId) {
                let $accordion = $('#' + sectionId + '-header');
                let $panel = $('#' + sectionId + '-content');

                $accordion.addClass('titleSectionActive');
                $panel.addClass('show');
            } else {
                accordions.on('click', function() {
                    toggleAccordion($(this));
                });
            }
        },

        openAccordion: function(_sectionId) {
            let $header = $('#' + _sectionId + '-header');
            let $content = $('#' + _sectionId + '-content');
            if (!_sectionId || !$header.length || !$content.length) return;

            $header.addClass('titleSectionActive');
            $content.addClass('show');
        },

        openTab: function(_event, _tabName) {
            $('.tabs label').removeClass('active');
            $('#' + _tabName).prop('checked', true);
            $('#' + _tabName + '-content').show();
            if(_event.currentTarget) {
                $(_event.currentTarget).addClass('active');
            }
        },

        handleAnchorClick: function() {
            $('[data-senix-anchor]').on('click', (event) => {
                event.preventDefault();
                let $this = $(event.currentTarget);
                let sectionId = $this.data('senix-anchor');
                let accordion = $this.data('senix-accordion');
                let tabName = $this.data('senix-tab');
                let $section = $('#' + sectionId);

                if (sectionId && $section.length) $section[0].scrollIntoView({ behavior: 'smooth' });
                if (accordion) this.openAccordion(accordion);
                if (tabName) this.openTab(event, tabName);
            });
        },

        shortenBeforeComma(_text) {
            if (typeof _text !== 'string') return '';
            return _text.split(',')[0];
        },

        shortenProductTitle: function() {
            $('.shorten-title').each(function() {
                let newText = customProductDetail.shortenBeforeComma($(this).text());
                $(this).text(newText);
            });
        },

        sideNav: function() {
            let sideLinks = $('.senix--side-nav-list-link');

            let windowHeight = $win.height();
            let fromTop = $win.scrollTop();
            let maxVisibleHeight = 0;
            let currentSectionId = '';

            sideLinks.removeClass('current');

            sideLinks.each(function() {
                let sectionId = $(this).attr('href');
                let section = $(sectionId);

                if (section.length) {
                    let sectionTop = section.offset().top;
                    let sectionHeight = section.outerHeight();

                    let visibleHeight = Math.min(sectionTop + sectionHeight, fromTop + windowHeight) - Math.max(sectionTop, fromTop);

                    if (visibleHeight > 0) {
                        if (visibleHeight > maxVisibleHeight) {
                            maxVisibleHeight = visibleHeight;
                            currentSectionId = sectionId;
                        }
                    }
                }
            });

           $(`[href="${currentSectionId}"]`).addClass('current');
        },
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Collect all PDP content wrappers in DOM order
        const wrappers = Array.from(document.querySelectorAll(
          '#product-overview .section, #additional-info .section, #specs .section, #related-products .section, #product-video .section, #reviews .section, #user-manual-parts-list .section, #product-support .section'
        )).map(el => el.closest('.section-wrapper, .section-wrapper-video, .bg-white, .bg-off-white'));

        // Filter out any nulls and hidden elements
        const visible = wrappers.filter(w => w && w.offsetParent !== null);

        // Normalize any previous bg classes, then alternate starting with gray
        visible.forEach((wrap, idx) => {
          wrap.classList.remove('bg-white', 'bg-off-white');
          wrap.classList.add(idx % 2 === 0 ? 'bg-off-white' : 'bg-white'); // 0 = first = gray (#f8f8f8)
        });
    });

})(jQuery);
